import React, { Component } from 'react';

import characters from '../characters.json'; 

function OneCharacter(props){  
    return (
        <li className={ props.active ? "active-character":null } onClick={ props.onClick }>
        <span>{props.icon}</span>
        </li>
    );
}

class CharacterList extends Component {
    constructor(props) {
        super(props); 
        this.state = {
            options: [{

            }],
            characters: characters.slice(),
            activeList:{
                [this.props.activeCharacterId + '-active']:true
            },
        };
    }

    render() {
        //console.log("current active ", this.props.activeCharacterId);
        this.characters = this.state.characters.map((item, key) =>
        {
            return (
            <OneCharacter 
                key={item.id}
                characterId={item.id} 
                icon={item.icon} 
                name={item.name}
                active={this.state.activeList[key +'-active']}
                onClick={() => {
                    this.props.onClick(item);
                    //this.state[key +'-active']
                    this.setState({ 
                    activeList:{
                        [item.id +'-active']: true
                    }
                    });
                }
                }
            />
            )
        }
        );

        return (    
        <div className="character-list">
            <ul>
            {this.characters}
            </ul>
        </div>
        );
    }
}
export default CharacterList;